module.exports = __webpack_public_path__ + "img/iguana-tatuada-400.da347adc.webp";